import React, { useState } from "react";
import { StyleSheet, View } from "react-native";

import { AttributeCardDisplayVariantType, AttributeCardType } from "../types";

import OptionSelectionModal from "./Modal/OptionSelectionModal";

import AttributeCard from "@/Components/PersonalAttributes/Components/AttributeCard";
import { type AttributeValue } from "@/schemas/attribute/AttributeSet";
import { type AppUserSession } from "@/schemas/auth/session";
import { type UserAttributeSet } from "@/schemas/profile/UserAttributeSet";
import ProfileService from "@/services/user/profile";

export interface AttributeSelectionCardProps {
  session: AppUserSession;
  attribute: UserAttributeSet;
  values: AttributeValue[];
  icon: string;
  variant: AttributeCardDisplayVariantType;
  fullWidth?: boolean;
}

function AttributeSelectionCard({
  session,
  attribute,
  values,
  icon,
  variant,
  fullWidth = false,
}: AttributeSelectionCardProps): React.JSX.Element {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedOptions, setSelectedOptions] =
    useState<AttributeValue[]>(values);

  const updateValues = async (
    selectedItems: AttributeValue[],
  ): Promise<void> => {
    try {
      setSelectedOptions(selectedItems);
      const profileService = new ProfileService(session);
      const selectedOptionIds = selectedItems.map((item) => item.id);
      await profileService.updateAttributes(attribute.id, selectedOptionIds);
    } catch (error) {
      setShowModal(false);
    }
  };

  function onPress(): void {
    setShowModal(true);
  }

  return (
    <View
      style={[
        styles.container,
        variant === AttributeCardDisplayVariantType.ACCOUNT
          ? styles.containerHalfWidth
          : fullWidth
            ? styles.containerFullWidth
            : styles.containerHalfWidth,
      ]}
    >
      <AttributeCard
        attributeType={AttributeCardType.SELECTION}
        attributeId={attribute.id}
        values={selectedOptions}
        onPress={onPress}
        icon={icon}
        isDisabled={false}
        variant={variant}
      />
      <OptionSelectionModal
        attribute={attribute}
        values={values}
        showModal={showModal}
        closeModal={() => setShowModal(false)}
        updateAttributes={updateValues}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginBottom: 12,
  },
  containerFullWidth: {
    width: "100%",
  },
  containerHalfWidth: {
    width: "48%",
  },
});

export default AttributeSelectionCard;
